import React, {Component} from "react";
import './SniperCamButton.css'

export default class SniperCamButton extends Component {
    constructor(props) {
        super(props);
        this.text = props.text
        this.button_type = props.button_type ? " " + props.button_type : " RedButton"
        this.large = props.large ? " Large" : ""
        this.onClick = props.onClick
    }

    render() {
        return (
            <button className={"SniperCamButton" + this.button_type + this.large} onClick={() => {
                if (this.props.onClick) {
                    this.props.onClick()
                }
            }}>{this.props.text}
            </button>
        );
    }
}